module.exports = __webpack_public_path__ + "img/Luxembourg.46d44da2.svg";